export default __webpack_public_path__ + "static/media/enrichment.edae1bec.png";